import React from "react";
import FacebookAuth from "react-facebook-auth";
import TwitterLogin from "../../utils/TwitterLogin";
import GoogleLogin from "react-google-login";
import IconButton from "../LastPage/SocialActions/IconButton";
import { emptyFunction } from "../utilities";
import { AppleLogin } from "../../utils/AppleLogin";

const SocialLogins = ({
  title,
  fbAppId,
  appleClientId,
  appleRedirectUri,
  signInFBApiCallback,
  signInFBOnFailure,
  twitterRequestTokenUrl,
  twitterVerifyTokenUrl,
  signInTwitterApiCallback,
  signInTwitterOnFailure,
  signInGoogleApiCallback,
  signInGoogleOnFailure,
  signInAppleApiCallback,
  signInAppleOnFailure
}) => (
  <div>
    <p className="t-pb1 t-pt3 gray-2 a-font-size-2">{title}</p>
    <div className="pl3 pb1">
      <FacebookAuth
        appId={fbAppId}
        version="10.0"
        isMobile={false}
        callback={signInFBApiCallback}
        onFailure={signInFBOnFailure}
        component={({ onClick }) => (
          <IconButton icon="/images/webreader/ic-fb.svg" onClick={onClick} />
        )}
      />
      <TwitterLogin
        requestTokenUrl={twitterRequestTokenUrl}
        verifyTokenUrl={twitterVerifyTokenUrl}
        onFailure={signInTwitterOnFailure}
        onSuccess={signInTwitterApiCallback}
        tag="span"
      >
        <IconButton icon="/images/webreader/ic-twitter.svg" onClick={emptyFunction} />
      </TwitterLogin>

      <GoogleLogin
        clientId={process.env.GOOGLE_CONSUMER_KEY}
        onSuccess={signInGoogleApiCallback}
        onFailure={signInGoogleOnFailure}
        style={{ display: "inline-block" }}
        type="none"
        tag="span"
      >
        <IconButton icon="/images/webreader/ic-google.svg" onClick={emptyFunction} />
      </GoogleLogin>

      <AppleLogin
        onSuccess={signInAppleApiCallback}
        onFailure={signInAppleOnFailure}
        appleClientId={appleClientId}
        appleRedirectUri={appleRedirectUri}
      >
        <IconButton
          icon="/images/webreader/ic-apple.svg"
          className="t-mr2 t-mr3-ns"
          onClick={emptyFunction}
        />
      </AppleLogin>
    </div>
  </div>
);

SocialLogins.defaultProps = {
  title: "or connect with one of the social buttons",
  fbAppId: "",
  appleClientId: "",
  appleRedirectUri: "",
  twitterRequestTokenUrl: "",
  twitterVerifyTokenUrl: "",
  signInFBApiCallback: emptyFunction,
  signInFBOnFailure: emptyFunction,
  signInTwitterApiCallback: emptyFunction,
  signInTwitterOnFailure: emptyFunction,
  signInGoogleApiCallback: emptyFunction,
  signInGoogleOnFailure: emptyFunction,
  signInAppleApiCallback: emptyFunction,
  signInAppleOnFailure: emptyFunction
};

export { SocialLogins };
